import React from 'react';

import PropTypes from 'prop-types';
import { HiChevronLeft } from 'react-icons/hi';

import { Button } from 'modules/common/input';

function ActionButton({ status, onUpdateStatus, isLoading }) {
  const renderButton = {
    FOR_PICKUP: (
      <Button
        withLoader
        type="button"
        onClick={onUpdateStatus}
        label="Confirm Order"
        disabled={isLoading}
        isLoading={isLoading}
        className="btn md primary w-full"
      />
    ),
    IN_TRANSIT: (
      <Button
        withLoader
        type="button"
        onClick={onUpdateStatus}
        label="Complete Delivery"
        disabled={isLoading}
        isLoading={isLoading}
        className="btn md primary w-full"
      />
    ),
    default: (
      <Button
        onClick={onUpdateStatus}
        label="Go Back"
        to="/r/delivery"
        icon={<HiChevronLeft className="w-5 h-5" />}
        className="btn md primary w-full font-medium"
      />
    ),
  };
  return (
    <div className="fixed w-full bottom-0 left-0 z-20 bg-white">
      <div className="border-t border-gray-100 shadow-md py-5 flex">
        <div className="container px-3 lg:px-0 mx-auto w-full md:max-w-xl">
          <div className="w-full">
            {renderButton[status] || renderButton?.default}
          </div>
        </div>
      </div>
    </div>
  );
}
ActionButton.defaultProps = {};

ActionButton.propTypes = {
  status: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
  onUpdateStatus: PropTypes.instanceOf(Function).isRequired,
};

export default ActionButton;
